import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Award, Scale, Trophy, BookOpen, UserCheck, Shield, HeartPulse, FolderOpen, ArrowRight } from 'lucide-react';
const sections = [{
  name: 'Комітет скелелазіння',
  href: '/climbing/committee',
  icon: <Users className="h-5 w-5" data-id="element-535" />,
  description: 'Керівний орган скельного напрямку ФАіСУ.'
}, {
  name: 'Тренерська рада',
  href: '/climbing/coach-council',
  icon: <Award className="h-5 w-5" data-id="element-536" />,
  description: 'Тренерська рада скельного комітету ФАіСУ.'
}, {
  name: 'Колегія суддів',
  href: '/climbing/judges',
  icon: <Scale className="h-5 w-5" data-id="element-537" />,
  description: 'Колегія суддів скельного комітету ФАіСУ.'
}, {
  name: 'Комісія спортивного скелелазіння',
  href: '/climbing/sport-commission',
  icon: <Trophy className="h-5 w-5" data-id="element-538" />,
  description: 'Комісія спортивного скелелазіння ФАіСУ.'
}, {
  name: 'Навчально-методична комісія',
  href: '/climbing/education',
  icon: <BookOpen className="h-5 w-5" data-id="element-539" />,
  description: 'Навчально-методична комісія скельного комітету ФАіСУ.'
}, {
  name: 'Комісія атлетів',
  href: '/climbing/athletes',
  icon: <UserCheck className="h-5 w-5" data-id="element-540" />,
  description: 'Комісія атлетів скельного комітету ФАіСУ.'
}, {
  name: 'Комісія з етики',
  href: '/climbing/ethics',
  icon: <Shield className="h-5 w-5" data-id="element-541" />,
  description: 'Комісія з етики скельного комітету ФАіСУ.'
}, {
  name: 'Антидопінгова комісія',
  href: '/climbing/antidoping',
  icon: <HeartPulse className="h-5 w-5" data-id="element-542" />,
  description: 'Антидопінгова комісія скельного комітету ФАіСУ.'
}, {
  name: 'Документи',
  href: '/climbing/documents',
  icon: <FolderOpen className="h-5 w-5" data-id="element-543" />,
  description: 'Офіційні документи скельного комітету ФАіСУ.'
}];
export function ClimbingIndex() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-544">
      <Header data-id="element-545" />
      <main className="pt-20" data-id="element-546">
        <PageHero label="Скелелазіння" title="Скелелазіння" subtitle="Структура скельного комітету Федерації Альпінізму і Скелелазіння України — комісії, ради та робочі органи." data-id="element-547" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-548">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-549">
            {sections.map((section, index) => <motion.div key={section.href} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} data-id="element-550">
                <Link to={section.href} className="block bg-white rounded-lg border border-gray-200 shadow-sm p-6 group cursor-pointer hover:border-primary/20 hover:shadow-md transition-all" data-id="element-551">
                  <div className="flex items-start gap-4" data-id="element-552">
                    <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0 text-primary group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-553">
                      {section.icon}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-554">
                      <div className="flex items-center justify-between" data-id="element-555">
                        <h3 className="text-sm font-bold text-primary group-hover:text-primary-light transition-colors" data-id="element-556">
                          {section.name}
                        </h3>
                        <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-primary transition-colors flex-shrink-0" data-id="element-557" />
                      </div>
                      <p className="text-gray-500 text-sm mt-1.5 leading-relaxed" data-id="element-558">
                        {section.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-559" />
    </div>;
}